<template>
  <div></div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import config from '@/config'

export default {
  components: {
  },
  data() {
    return {
      keyPresentationAnswered: '',
    }
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('liveStatsV2', ['liveStatsVersionPrefix']),
  },

  mounted() {
    this.keyPresentationAnswered = `/${this.liveStatsVersionPrefix}/${config.livestatsTopicPrefix}/counting/presentation-${this.presentation.id}/everyone-answered-answer-${this.slideActive.id}-${this.slideActive.version}`
    this.subscribeEveryoneAnsweredAction({
      key: this.keyPresentationAnswered,
      callback: this.handleCounting,
    })
  },
  destroyed() {
    this.clearEveryoneAnsweredSlideAction()
    this.unsubscribeEveryoneAnsweredAction(this.keyPresentationAnswered)
  },

  methods: {
    ...mapActions([
      'subscribeEveryoneAnsweredAction',
      'unsubscribeEveryoneAnsweredAction',
      'checkEveryoneHasAnsweredAction',
      'setTotalAnsweredSlideAction',
      'clearEveryoneAnsweredSlideAction',
    ]),

    handleCounting(topic, msg) {
      if (!msg) return
      const message = JSON.parse(msg)
      this.setTotalAnsweredSlideAction({
        slideId: this.slideActive.id,
        count: message.total,
      })
      this.checkEveryoneHasAnsweredAction({
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
    },
  },
}
</script>
